import { defineStore } from 'pinia';
import { authApi } from '../api';
import { previewMode } from '../previewMode';

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: previewMode ? 'preview-local-only' : localStorage.getItem('admin_token') || null,
    user: previewMode ? { admin_id: 1, username: 'preview', display_name: 'ผู้ดูแลตัวอย่าง', role: 'superadmin' } : JSON.parse(localStorage.getItem('admin_user') || 'null'),
  }),

  getters: {
    isLoggedIn: (state) => !!state.token,
  },

  actions: {
    async login(username, password) {
      const { data } = await authApi.login({ username, password });
      this.token = data.token;
      this.user = data.user;
      localStorage.setItem('admin_token', data.token);
      localStorage.setItem('admin_user', JSON.stringify(data.user));
      return data;
    },

    async fetchMe() {
      if (previewMode) return;
      try {
        const { data } = await authApi.me();
        this.user = data.user;
        localStorage.setItem('admin_user', JSON.stringify(data.user));
      } catch {
        this.logout();
      }
    },

    logout() {
      this.token = null;
      this.user = null;
      if (previewMode) return;
      localStorage.removeItem('admin_token');
      localStorage.removeItem('admin_user');
    },
  },
});
